import { render, staticRenderFns } from "./TaskDataPoints.vue?vue&type=template&id=497c3f8a&scoped=true&"
import script from "./TaskDataPoints.vue?vue&type=script&lang=ts&"
export * from "./TaskDataPoints.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDataPoints.vue?vue&type=style&index=0&id=497c3f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c3f8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497c3f8a')) {
      api.createRecord('497c3f8a', component.options)
    } else {
      api.reload('497c3f8a', component.options)
    }
    module.hot.accept("./TaskDataPoints.vue?vue&type=template&id=497c3f8a&scoped=true&", function () {
      api.rerender('497c3f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/TaskDataPoints.vue"
export default component.exports